export default "__VITE_ASSET__DLJsZ$y8__"